import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ConvState } from '../useScenarioPlayer';

interface ConversationListProps {
  convs: ConvState[];
  activeKey: string | null;
  onSelect: (key: string) => void;
  onNewChat: () => void;
}

export const ConversationList = ({
  convs,
  activeKey,
  onSelect,
  onNewChat,
}: ConversationListProps): JSX.Element => (
  <div className="flex h-full w-60 shrink-0 flex-col gap-1 border-r border-neutral-200 pr-3">
    <button
      type="button"
      onClick={onNewChat}
      className={cn(
        'mb-2 flex items-center gap-2 rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm font-medium text-neutral-800 shadow-sm transition-colors hover:bg-neutral-50',
        activeKey === null && 'bg-neutral-100'
      )}
    >
      <Plus className="h-4 w-4" />
      Нов чат
    </button>
    <div className="flex-1 space-y-0.5 overflow-y-auto">
      {convs.map((conv) => (
        <button
          key={conv.key}
          type="button"
          onClick={() => onSelect(conv.key)}
          className={cn(
            'block w-full rounded-lg px-3 py-2 text-left transition-colors hover:bg-neutral-50',
            activeKey === conv.key && 'bg-blue-50'
          )}
        >
          <span
            className={cn(
              'block truncate text-sm',
              activeKey === conv.key ? 'font-medium text-[#0000FF]' : 'text-neutral-800'
            )}
          >
            {conv.conversation.title}
          </span>
          <span className={cn('text-xs', activeKey === conv.key ? 'text-blue-400' : 'text-neutral-400')}>
            {conv.conversation.seeded?.date ?? 'днес'}
          </span>
        </button>
      ))}
    </div>
  </div>
);
